module.exports = __webpack_public_path__ + "static/media/component-open.353cdea8.svg";